export default __webpack_public_path__ + "static/media/account.51b130c6.svg";